var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "pp-modal",
    {
      attrs: {
        "on-visible-change": "modelchange",
        "mask-closable": false,
        width: "488",
      },
      model: {
        value: _vm.showModal,
        callback: function ($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal",
      },
    },
    [
      _c(
        "p",
        { staticClass: "modalHead", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v(_vm._s(_vm.modalheader))])]
      ),
      _c("div", { staticClass: "modalContent" }, [
        _c("p", [
          _vm._v(
            _vm._s(_vm.modalcontent) +
              " " +
              _vm._s(_vm.currency) +
              " " +
              _vm._s(_vm.$filters.money(_vm.amount))
          ),
        ]),
        _c(
          "div",
          [
            _c(
              "pp-row",
              [
                _c(
                  "pp-col",
                  { attrs: { span: 12 } },
                  [
                    _c(
                      "pp-form",
                      {
                        ref: "formCustom",
                        staticClass: "formstyle",
                        attrs: { model: _vm.formCustom, rules: _vm.rules },
                      },
                      [
                        _c(
                          "pp-form-item",
                          {
                            staticClass: "control-input",
                            attrs: { prop: "confirmAmount" },
                          },
                          [
                            _c("pp-input", {
                              staticClass: "inputstyle",
                              attrs: {
                                value: _vm.formCustom.confirmAmount,
                                type: "text",
                                placeholder: _vm.currency,
                              },
                              on: { "on-blur": _vm.onchange },
                              model: {
                                value: _vm.formCustom.confirmAmount,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.formCustom,
                                    "confirmAmount",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "formCustom.confirmAmount",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("pp-col", { attrs: { span: 12 } }, [
                  _c(
                    "div",
                    { staticClass: "all", on: { click: _vm.getAllAmount } },
                    [_vm._v(_vm._s(_vm.$t("webList.webDetail.allFunds")))]
                  ),
                ]),
              ],
              1
            ),
            _c("p", { staticClass: "tip-text" }, [
              _vm._v(
                _vm._s(_vm.$t("webList.webDetail.withdrawalFee")) +
                  "（" +
                  _vm._s(_vm.currency) +
                  "）：" +
                  _vm._s(_vm.$filters.money(_vm.feeAmount))
              ),
            ]),
            _c("p", { staticClass: "tip-text" }, [
              _vm._v(
                _vm._s(_vm.$t("webList.webDetail.estimatedTransferredAmount")) +
                  "（" +
                  _vm._s(_vm.currency) +
                  "）：" +
                  _vm._s(_vm.$filters.money(_vm.withdrawAmount))
              ),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("ul", { staticClass: "attention" }, [
            _c("li", [_vm._v(_vm._s(_vm.$t("webList.webDetail.attention")))]),
            _c("li", [
              _vm._v(_vm._s(_vm.$t("webList.webDetail.attentionLine1"))),
            ]),
            _c("li", { staticStyle: { padding: "18px 0 18px" } }, [
              _vm._v(_vm._s(_vm.$t("webList.webDetail.attentionLine2"))),
            ]),
          ]),
          _c(
            "pp-button",
            {
              attrs: {
                type: "primary",
                size: "spec",
                loading: _vm.loading2,
                disabled: _vm.isDisabledWithdraw,
              },
              on: {
                click: function ($event) {
                  return _vm.commit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("webList.webDetail.confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }